export function resolveRowKey<T>(el: T, rowKey: keyof T): string {
  return el[rowKey] as string;
}
